<template>
    <v-container class="container-terms">
        <v-row>
            <v-col cols="12" sm="12">
                <div>
                    <p align="center">
                        <strong>SERVICES AGREEMENT</strong>
                    </p>
                    <p>
                        <strong>Last Modified: 09</strong>
                        <sup><strong>th</strong></sup>
                        <strong> Oct. 2021</strong>
                    </p>
                    <p>
                        PLEASE READ THIS SERVICES AGREEMENT CAREFULLY
                    </p>
                    <p align="justify">
                        This is a contract between you and us (Sofos Learning
                        Solutions Private Limited). It describes how we will
                        work together and other aspects of our business
                        relationship. These terms are so important though that
                        we cannot have you participate in our Services Agreement
                        unless you agree to them. By accepting our Services
                        Agreement, you are agreeing to these terms. We
                        periodically update these terms, and you can find the
                        most recent version on the platform.
                    </p>
                    <ol>
                        <li>
                            <p lang="en-US" align="justify">
                                <strong>Definitions:</strong>
                            </p>
                        </li>
                    </ol>
                    <p align="justify">
                        "Platform" means our web-based inbound platforms that we
                        may make available to you, and is developed, operated,
                        and maintained by us, accessible via
                        https://eduracle.com or another designated URL, and any
                        ancillary products and services, that we provide to you
                        for your use in accordance with the terms of this
                        Agreement.
                    </p>
                    <p align="justify">
                        "Content" means all information, data, text, messages,
                        software, sound, music, video, photographs, graphics,
                        images, and tags that we incorporate into our Platform
                        resources and make available to you under this
                        Agreement.
                    </p>
                    <p align="justify">
                        "Agreement" means this Agreement and all materials
                        referred or linked to in here.
                    </p>
                    <p align="justify">
                        “Confidential Information” means all confidential
                        information disclosed by a party ("Disclosing Party") to
                        the other party ("Receiving Party"), whether orally or
                        in writing, that is designated as confidential. Whether
                        or not marked or designated as confidential,
                        Confidential Information shall include all information
                        concerning: (a) Disclosing Party's customer and prospect
                        information, including Customer Data and Customer
                        Materials, as defined in the Customer Terms of Service
                        (b) Disclosing Party's past, present or proposed
                        products, marketing plans, engineering and other
                        designs, technical data, business plans, business
                        opportunities, finances, research and development
                        materials. Confidential Information shall not include
                        any information that (i) is or becomes generally known
                        to the public without breach of any obligation owed to
                        the Disclosing Party, (ii) was known to the Receiving
                        Party prior to its disclosure by the Disclosing Party
                        without breach of any obligation owed to the Disclosing
                        Party, (iii) is received from a third party without
                        breach of any obligation owed to the Disclosing Party,
                        or (iv) was independently developed by the Receiving
                        Party.
                    </p>
                    <p align="justify">
                        “Customer Terms of Service” means those terms and
                        conditions located at the various subdomains of
                        https://eduracle.com as modified from time to time.
                    </p>
                    <p align="justify">
                        “Educational Program” means an organized program of
                        instruction that is offered and maintained by an
                        accredited educational institution and leads to the
                        award of a certificate, diploma or degree upon
                        satisfactory completion of course work requirements.
                    </p>
                    <p align="justify">
                        “End User” means the authorized and actual user of the
                        Platform, which may include students enrolled in
                        educational programs with Partner.
                    </p>
                    <p align="justify">
                        "We", "us", “our”, “Provider” , “Platform” and
                        “Eduracle” means Sofos Learning Solutions Private
                        Limited.
                    </p>
                    <p align="justify">
                        “You”, “Institute” and “Partner” means the party, other
                        than Sofos Learning Solutions Private Limited, entering
                        into this Agreement. For the purpose of this Services
                        Agreement, You means the academic entity, school,
                        college or university that applied to participate in
                        this Services Agreement.
                    </p>
                    <ol>
                        <li>
                            <p lang="en-US" align="justify">
                                <strong>Effective Date and Term:</strong>
                            </p>
                        </li>
                    </ol>
                    <p lang="en-US" align="justify">
                        This Agreement will apply for as long as you participate
                        in our Platform until terminated.
                    </p>
                    <ol start="2">
                        <li>
                            <p lang="en-US" align="justify">
                                <strong>Our Support:</strong>
                            </p>
                        </li>
                    </ol>
                    <ol type="a">
                        <li>
                            <p lang="en-US" align="justify">
                                Provider will create, establish an online
                                platform for attempting questions to the
                                students of the institute. The Platform will
                                have the name of the Institute as well as the
                                Provider or its subsidiary. The platform shall
                                be accessible at your dedicated subdomain under
                                https://eduracle.com.
                            </p>
                        </li>
                        <li>
                            <p lang="en-US" align="justify">
                                The institute will be able to upload its
                                questions on the Platform and evaluate its
                                students.
                            </p>
                        </li>
                        <li>
                            <p lang="en-US" align="justify">
                                The Institute Coordinators will have the ability
                                to make customized tests for its students.
                            </p>
                        </li>
                        <li>
                            <p lang="en-US" align="justify">
                                The Provider will provide online customized
                                reports, analysis for the tests conducted on its
                                platform.
                            </p>
                        </li>
                        <li>
                            <p lang="en-US" align="justify">
                                The Provider will ensure the stability of the
                                platform with 99% uptime.
                            </p>
                        </li>
                        <li>
                            <p lang="en-US" align="justify">
                                If required, the Provider can accommodate
                                training for the staff members of the institute
                                as per agreed terms.
                            </p>
                        </li>
                        <li>
                            <p lang="en-US" align="justify">
                                Provider will specifically allot a service
                                manager with whom the institute can co-ordinate
                                in case of any technical issue on the platform.
                            </p>
                        </li>
                        <li>
                            <p lang="en-US" align="justify">
                                Marketing &amp; Promotion. Provider will market
                                and promote its services and courses on the
                                Platform and to the Users of the Platform and
                                the Institute gives this right specifically to
                                the Provider.
                            </p>
                        </li>
                        <li>
                            <p lang="en-US" align="justify">
                                The Provider will not bear any responsibility
                                for the content on the platform.
                            </p>
                        </li>
                    </ol>
                    <ol start="3">
                        <li>
                            <p lang="en-US" align="justify">
                                <strong>Fees</strong>
                                . In exchange for creating the Online Platform
                                and providing the Services under this Agreement,
                                the Institute will pay to Provider the fees per
                                student or per course, as is visible on the
                                website or designated url. (“Service Fee”).
                                Minimum registrations may apply.
                            </p>
                        </li>
                    </ol>
                    <ol type="a">
                        <li>
                            <p lang="en-US" align="justify">
                                Invoicing and Payment Terms. The Institute will
                                be able to see the Service Fee due with an
                                itemized statement outlining how they have been
                                derived on the website. The Fees would be paid
                                in advance on or before the registration of the
                                User.
                            </p>
                        </li>
                        <li>
                            <p lang="en-US" align="justify">
                                No Refunds after registration of User. Provider
                                maintains a “no refund policy” after the final
                                registration of the User on the Platform.
                                However, the Provider will consider adjusting
                                the fees paid only if the institute upgrades to
                                services or continues with further registration
                                of users as is mutually decided. Fees adjustment
                                will be the sole discretion of the Provider.
                            </p>
                        </li>
                        <li>
                            <p lang="en-US" align="justify">
                                No Resale of Content Materials. Neither the
                                Provider nor the Institute will copy the
                                Material available on the Platform. The parties
                                will not participate in reselling or permit the
                                resale of the Materials available on the
                                Platform, unless permission is granted by party,
                                in writing.
                            </p>
                        </li>
                    </ol>
                    <ol start="4">
                        <li>
                            <p lang="en-US" align="justify">
                                <strong
                                    >Responsibilities of the Institute:</strong
                                >
                            </p>
                        </li>
                    </ol>
                    <ol type="a">
                        <li>
                            <p lang="en-US" align="justify">
                                The Institute will register all students through
                                the registration process. Enrollment numbers
                                will be available to Provider upon request. The
                                Institute will create separate account for each
                                and every user on the Platform.
                            </p>
                        </li>
                        <li>
                            <p lang="en-US" align="justify">
                                Institute can generate online reports on the
                                platform.
                            </p>
                        </li>
                        <li>
                            <p lang="en-US" align="justify">
                                In case of any technical issue the institute
                                will inform the Provider.
                            </p>
                        </li>
                        <li>
                            <p lang="en-US" align="justify">
                                Records. The Institute will give Provider a
                                complete list of students enrolled on the
                                Platform and their contact information. The
                                Provider can also access the enrolled user’s
                                data through the Platform and in turn can
                                promote its services to the Users of the
                                Platform.
                            </p>
                        </li>
                    </ol>
                    <ol start="5">
                        <li>
                            <p lang="en-US" align="justify">
                                <strong>Intellectual Property</strong>
                                . All property created and/or delivered by
                                Provider or Institute shall remain the exclusive
                                property of the respective Party, including, but
                                not limited to, all patents, trademarks and
                                copyrights in the Platform Content, program
                                structure etc. Neither the Provider nor the
                                Institute shall have the right to transfer any
                                intellectual property belonging to other party.
                                Such property shall include the Parties name,
                                program names, curriculum, and materials. Of
                                those components thereof purchased by Parties or
                                licensed by Parties from another party, Parties
                                warrants that it has paid for and owns the legal
                                right and license to use, distribute and resell
                                such components. The Institute agrees to
                                indemnify us against third party claims or
                                actions for infringement due to the use or
                                dissemination of Third-Party Intellectual
                                Property.
                            </p>
                        </li>
                    </ol>
                    <p lang="en-US" align="justify">
                        5.1. <em>Grant of License</em>. Provider hereby grants a
                        non-exclusive license to the Institute and its agents
                        and employees to use the Intellectual Property in
                        connection with the Platform only during the term of
                        this Agreement. This license grants a limited right,
                        title and interest in Provider’s name, logo, and its
                        promotional materials.
                    </p>
                    <p lang="en-US" align="justify">
                        5.2. <em>Nondisclosure and Non-solicitation</em>. In
                        order for any trade secret information to be held
                        confidential, Provider agrees to identify what
                        information it deems as a trade secret and explain why
                        it deserves such protection.
                    </p>
                    <ol>
                        <li>
                            <p lang="en-US" align="justify">
                                <strong>Confidentiality</strong>
                                :
                            </p>
                        </li>
                    </ol>
                    <p lang="en-US" align="justify">
                        The Receiving Party shall: (i) protect the
                        confidentiality information of the Disclosing Party
                        using the same degree of care that it uses with its own
                        confidential information, but in no event less than
                        reasonable care, (ii) not use any Confidential
                        Information of the Disclosing Party for any purpose
                        outside the scope of this Agreement, (iii) not disclose
                        Confidential Information of the Disclosing Party to any
                        third party, and (iv) limit access to Confidential
                        Information of the Disclosing Party to those of its
                        employees, contractors and agents who need such access
                        for purposes consistent with this Agreement.
                    </p>
                    <p lang="en-US" align="justify">
                        b. The Receiving Party may disclose Confidential
                        Information of the Disclosing Party if required to do so
                        under any law.
                    </p>
                    <p lang="en-US" align="justify">
                        c. Injunctive Relief. Each party acknowledges that the
                        unauthorized use or disclosure of the other party’s
                        Confidential Information may cause irreparable harm to
                        the other party. Accordingly, each party agrees that the
                        other party will have the right to seek an immediate
                        injunction against any breach or threatened breach of
                        this “Confidentiality” section of this Agreement, as
                        well as the right to pursue any and all other rights and
                        remedies available at law or in equity for such a
                        breach.
                    </p>
                    <ol start="3">
                        <li>
                            <p lang="en-US" align="justify">
                                <strong>Representations of Parties</strong>
                                . The parties represent as follows:
                                <br />
                                <em
                                    >Performance Violates No Law or
                                    Agreements</em
                                >
                                . As far as the Parties are aware, the execution
                                and performance of this Agreement does not
                                contravene any law, governmental rule or
                                regulation, or any provision of any other
                                agreement to which Provider and Institute are a
                                party.
                            </p>
                        </li>
                    </ol>
                    <ol start="4">
                        <li>
                            <p lang="en-US" align="justify">
                                <strong
                                    >Specific Authority to Provider from
                                    Institute:</strong
                                >
                            </p>
                        </li>
                    </ol>
                    <p lang="en-US" align="justify">
                        The Institute gives specific authority to the Provider
                        to contact its students or users for promotion of their
                        courses and Programs. If any user upgrades to the course
                        or program of the Provider by paying individual fees,
                        then it is deemed that the Institute gave its NOC to the
                        user to use the platform and opt for specific courses or
                        programs. The institute will not charge any fees to the
                        user or provider separately for opting courses on the
                        platform. Neither the Provider will share any fees with
                        the Institute for such upgradation of services by the
                        user.
                    </p>
                    <ol start="5">
                        <li>
                            <p lang="en-US" align="justify">
                                <strong>Termination</strong>
                                . In the event that either party defaults under
                                this Agreement, the non-defaulting party may
                                send written notice to the defaulting party of
                                said default. If the defaulting party fails to
                                correct said default within thirty (30) days of
                                receipt of written notice, then the
                                non-defaulting party may terminate this
                                Agreement and shall be entitled to seek any
                                remedy available at law or in equity. In
                                addition to the foregoing, this Agreement may be
                                terminated upon mutual consent of Provider and
                                the Institute. Any Termination will go into
                                effect upon completion of the then-currently
                                running Agreement.
                            </p>
                        </li>
                    </ol>
                    <p lang="en-US" align="justify">
                        Effects of Expiration/Termination. Upon termination or
                        expiration, parties will discontinue all use of and
                        delete all Content, cease promoting your partner status,
                        and will immediately discontinue all use of our
                        trademarks if applicable.
                    </p>
                    <ol start="6">
                        <li>
                            <p lang="en-US" align="justify">
                                <strong
                                    >Disclaimers; Limitations of
                                    Liability:</strong
                                >
                            </p>
                        </li>
                    </ol>
                    <p lang="en-US" align="justify">
                        a. Disclaimer of Warranties. We and our affiliates and
                        agents make no representations or warranties about the
                        suitability, reliability, availability, timeliness,
                        security or accuracy of the products or services for any
                        purpose. The platform may not be available at all times.
                        To the extent permitted by law, the platform products
                        and services are provided "as is" without warranty or
                        condition of any kind. We disclaim all warranties and
                        conditions of any kind with regard to the platform
                        products and services including all implied warranties
                        or conditions of merchantability, fitness for a
                        particular purpose, title, and non-infringement. We will
                        not be held liable due to technical failure for which we
                        are not responsible.
                    </p>
                    <p lang="en-US" align="justify">
                        b. No Indirect Damages. To the extent permitted by law,
                        in no event shall we be liable for any indirect,
                        punitive, or consequential damages, including lost
                        profits or business opportunities.
                    </p>
                    <p lang="en-US" align="justify">
                        c. Limitation of Liability. If, notwithstanding the
                        other terms of this agreement, we are determined to have
                        any liability to you or any third party, the parties
                        agree that our aggregate liability will be limited to
                        the amount you have paid for our services and not more
                        than that as per the latest agreement between us.
                    </p>
                    <ol start="7">
                        <li>
                            <p lang="en-US" align="justify">
                                <strong>Data Processing.</strong>
                                To the extent that any Personal Data is
                                processed in connection with the Agreement the
                                terms set forth in the Privacy Policy of
                                Eduracle (posted at the various subdomains of
                                https://eduracle.com, which are hereby
                                incorporated by reference, shall apply.
                            </p>
                        </li>
                    </ol>
                    <ol start="8">
                        <li>
                            <p lang="en-US" align="justify">
                                <strong>General Clauses</strong>
                            </p>
                        </li>
                    </ol>
                    <p lang="en-US" align="justify">
                        <em>12.1 Assignment</em>
                        . This Agreement is personal and is assignable or
                        transferable only upon the prior written consent of the
                        Institute. This Agreement is binding on, and inures to
                        the benefit of, and is enforceable by, the Parties and
                        their respective successors and assigns.
                        <br />
                        12.2. <em>Counterparts</em>. This Agreement may be
                        executed in one or more counterparts, each of which will
                        be deemed an original, and all of which together will be
                        considered one and the same Agreement, binding on all of
                        the Parties, even if all of the Parties have not signed
                        the same original or the same counterpart.
                    </p>
                    <p lang="en-US" align="justify">
                        12.3. <em>Governing Law; Choice of Forum</em>. This
                        Agreement will be governed by the laws of India and the
                        courts in Pune will have exclusive jurisdiction to try
                        any dispute arising from the use of this Platform. By
                        using this Website or ordering Services, you consent to
                        the jurisdiction and venue of such courts in connection
                        with any action, suit, proceeding, or claim arising
                        under or by reason of this Agreement.
                    </p>
                    <p lang="en-US" align="justify">
                        12.4. <em>Entire Agreement</em>. This Agreement
                        supersedes and takes the place of any and all previously
                        written or oral agreements, representations and
                        negotiations, if any, between the parties covering the
                        terms of this Services Agreement. The Parties may amend
                        this Agreement only upon written mutual consent.
                    </p>
                    <p lang="en-US" align="justify">
                        12.5. <em>Interpretation of Agreement and Headings</em>.
                        The section headings in this Agreement are for reference
                        and convenience purposes only, will not be considered in
                        the construction of this Agreement, and will not affect
                        the meaning or interpretation of it.
                        <br />
                        12.6. <em>Severability</em>. If any provision,
                        paragraph, sentence, or word of this Agreement is
                        declared void by a court of competent jurisdiction; then
                        the provision, paragraph, sentence, or word will be
                        severed from this Agreement, and the remainder of the
                        Agreement will remain in effect.
                    </p>
                    <p lang="en-US" align="justify">
                        <strong>12</strong>
                        .7. Force Majeure. Neither party will be responsible for
                        failure or delay of performance if caused by: an act of
                        war, hostility, or sabotage; act of God; electrical,
                        internet, or telecommunication outage that is not caused
                        by the obligated party; government restrictions; or
                        other event outside the reasonable control of the
                        obligated party. Each party will use reasonable efforts
                        to mitigate the effect of a force majeure event.
                    </p>
                    <p lang="en-US" align="justify">
                        <strong>12</strong>
                        .8. Relationship of the Parties. Both you and we agree
                        that no joint venture, partnership, employment, or
                        agency relationship exists between you and us as a
                        result of this Agreement.
                    </p>
                    <ol start="9">
                        <li>
                            <p lang="en-US" align="justify">
                                Non-Solicitation
                            </p>
                        </li>
                    </ol>
                    <p lang="en-US" align="justify">
                        You agree not to intentionally solicit for employment
                        any of our employees or contractors during the term of
                        this Agreement and for a period of twelve (12) months
                        following the termination or expiration of this
                        Agreement. Both you and we acknowledge that (i) any
                        newspaper or other general or public solicitation not
                        directed specifically to such person shall not be deemed
                        to be a solicitation for purposes of this provision, and
                        (ii) this provision is not intended to limit the
                        mobility of either our employees or contractors.
                    </p>
                    <ol start="10">
                        <li>
                            <p lang="en-US" align="justify">
                                <strong>Non-Exclusivity</strong>
                            </p>
                        </li>
                    </ol>
                    <p lang="en-US" align="justify">
                        This Agreement does not create an exclusive agreement
                        between you and us. Both you and we will have the right
                        to recommend similar products and services of third
                        parties and to work with other parties in the same or
                        similar capacity.
                    </p>
                    <ol start="11">
                        <li>
                            <p lang="en-US" align="justify">
                                <strong>Notices</strong>
                                . Notice will be sent to the contact address set
                                forth herein (as such may be changed by notice
                                given to the other party), and will be deemed
                                delivered as of the date of actual receipt.
                            </p>
                        </li>
                    </ol>
                    <p lang="en-US" align="justify">
                        <strong></strong>
                        The Provider:
                    </p>
                    <p lang="en-US" align="justify">
                        Sofos Learning Solutions Private Limited
                    </p>
                    <p lang="en-US" align="justify">
                        Cabin No. 23, 2nd Floor, West Block,
                    </p>
                    <p lang="en-US" align="justify">
                        Amanora Mall, Mundhwa–Kharadi Road,
                    </p>
                    <p lang="en-US" align="justify">
                        Amanora Park Town, Pune, Maharashtra – 411028
                    </p>
                    <p lang="en-US" align="justify">
                        Email: hello@eduracle.com
                    </p>
                    <p lang="en-US" align="justify">
                        To you: your address as provided in our personal account
                        information for you. We may give electronic notices
                        specific to you by email to your e-mail address(es) on
                        record in our account information for you. We may give
                        notice to you by telephone calls to the telephone
                        numbers on record in our account information for you.
                    </p>
                    <p align="justify">
                        <br />
                        The Provider and the Institute further warrant that they
                        have the right and power to enter into the Agreement and
                        that they do not have conflicting agreements with any
                        other party.
                    </p>
                </div>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
    name: "Terms-and-condtions",
    mounted() {},
    data() {
        return {};
    },

    methods: {},
};
</script>
